import { render, staticRenderFns } from "./SharingTwitterMetadata.vue?vue&type=template&id=2236d422&"
import script from "./SharingTwitterMetadata.vue?vue&type=script&lang=js&"
export * from "./SharingTwitterMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports